import {GET_SCOREBOARD_START, GET_SCOREBOARD_SUCCESS, GET_SCOREBOARD_FAIL, GET_SCOREBOARD_RESET} from './constants';
import {GetScoreboardActions, GetScoreboardState} from './types';

const initialState: GetScoreboardState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetScoreboardActions,
): GetScoreboardState => {
  switch (action.type) {
    case GET_SCOREBOARD_START:
      return {
        ...initialState,
        loading: true,
      };
    case GET_SCOREBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_SCOREBOARD_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_SCOREBOARD_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
